import { render, staticRenderFns } from "./AddRestrictionForm.vue?vue&type=template&id=f4ea0ba2&scoped=true"
import script from "./AddRestrictionForm.vue?vue&type=script&lang=ts"
export * from "./AddRestrictionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ea0ba2",
  null
  
)

export default component.exports